import React from 'react'

function CommentBubble (props) {

    return(
       <div className="shadow rounded m-2 p-5">
           <h5>{props.comment}</h5>
       </div>
    )
}

export default CommentBubble